import React, { Component } from 'react';
import "./MessageBubble.css";
import Api from "../../customlib/Api";
import { FaFile } from "react-icons/fa";
import ImageZoom from 'react-medium-image-zoom';
import {
    LocationOn, Done, DoneAll, Replay, Error, ReportOff, QueryBuilder,
    Assignment, Help, MoreVert, Face, Announcement, ContentCopy, Check
} from "@mui/icons-material";
import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemText, Menu, MenuItem, Tooltip as ToolTip, Typography } from "@mui/material";
import ReactPlayer from "react-player";
import Global from "../../customlib/Global";
import axios from 'axios';
import MyAudioPlayer from '../../customlib/MyAudioPlayer';
import LinkPreview, { URL_REGEX, isUrl, extractUrls, normalizeUrl } from '../LinkPreview';

/**
 * MessageBubble — versi revamp dari komponen Message dengan tampilan
 * bubble chat ala WhatsApp (incoming putih kiri, outgoing hijau kanan,
 * ekor bubble, jam + status di pojok bubble). Fungsionalitas dipertahankan
 * sama persis: TEXT, IMAGE/STICKER, DOCUMENT, LOCATION, AUDIO, VIDEO,
 * CONTACTS, reply, preview URL, catatan revisi, dan menu aksi.
 */
class MessageBubble extends Component {
    state = {
        isMenuOpen: false,
        anchorEl: null,
        showRevisionLog: false,
        revisoinLogs: "",
        showErrorMessage: false,
        errorCopied: false,
    }

    // Salin konten error box ke clipboard
    handleCopyErrorInfo = () => {
        const { data } = this.props;
        const text = [
            "Error Message: " + (data.errorMessage || data.errorCodeDescription || "-"),
            "Message UUID: " + (data.messageId || "-"),
            "Message Record ID: " + (data._id || "-"),
        ].join("\n");

        const onDone = () => {
            this.setState({ errorCopied: true }, () => {
                setTimeout(() => this.setState({ errorCopied: false }), 1500);
            });
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(onDone).catch(() => this.fallbackCopy(text, onDone));
        } else {
            this.fallbackCopy(text, onDone);
        }
    }

    fallbackCopy = (text, onDone) => {
        try {
            const ta = document.createElement("textarea");
            ta.value = text;
            ta.style.position = "fixed";
            ta.style.opacity = "0";
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            document.body.removeChild(ta);
            onDone();
        } catch (e) {
            console.error("Copy failed", e);
        }
    }

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget, isMenuOpen: true });
    };

    handleClose = () => {
        this.setState({ anchorEl: null, isMenuOpen: false });
    };

    toggleShowErrorMessage = () => {
        this.setState({ showErrorMessage: !this.state.showErrorMessage });
    }

    // ---------- Text helpers ----------
    formatText = () => {
        if (this.props.data.message.type === "TEXT") {
            return this.props.data.message.text !== undefined ? this.replaceNewLine(this.props.data.message.text) : "";
        } else {
            return this.props.data.message.caption !== undefined ? this.replaceNewLine(this.props.data.message.caption) : "";
        }
    }

    // Ubah URL di dalam teks menjadi link yang bisa diklik
    linkify = (text) => {
        if (text === undefined || text === null || typeof text !== "string") {
            return text;
        }

        const parts = text.split(URL_REGEX);
        return parts.map((part, index) => {
            if (part && isUrl(part)) {
                const href = normalizeUrl(part);
                return (
                    <a
                        key={index}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#027eb5", textDecoration: "underline", wordBreak: "break-all" }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    }

    replaceNewLine = (text) => {
        var splitted = text.split("\n");
        if (splitted.length <= 1) {
            return this.linkify(text);
        }
        return splitted.map((str, index) => <Box key={index}>{this.linkify(str)}</Box>);
    }

    // Ambil URL pertama dari teks/caption pesan untuk ditampilkan sebagai preview
    getMessageUrls = () => {
        const message = this.props.data.message;
        const source = message.type === "TEXT" ? message.text : message.caption;
        return extractUrls(source);
    }

    // ---------- Reply ----------
    formatReplyMessage = (replyData) => {
        if (replyData.message === undefined) {
            return <div className="wa-reply">Reply data missing</div>;
        }

        const msg = replyData.message;
        if (msg.type === "TEXT") {
            return (
                <div className="wa-reply">
                    <div className="wa-reply-title">Membalas</div>
                    {msg.text}
                </div>
            );
        }
        if (msg.type === "IMAGE") {
            return (
                <div className="wa-reply">
                    <div className="wa-reply-title">Foto</div>
                    {msg.caption}
                    <img className="wa-reply-thumb" src={Api.getBaseImageUrl() + msg.fileName} alt="" />
                </div>
            );
        }
        if (msg.type === "DOCUMENT") {
            return (
                <div className="wa-reply">
                    <div className="wa-reply-title">Dokumen</div>
                    {msg.caption}
                </div>
            );
        }
        return <div className="wa-reply">{msg.caption || msg.text}</div>;
    }

    // ---------- File / map ----------
    downloadFile = (url) => {
        const fileName = url.split("/").pop();
        const aTag = document.createElement("a");
        aTag.href = url;
        aTag.setAttribute("download", fileName);
        aTag.setAttribute("target", "_blank");
        document.body.appendChild(aTag);
        aTag.click();
        aTag.remove();
    }

    handleOpenMap = (latitude, longitude) => {
        const url = `https://maps.google.com/maps?ll=${latitude},${longitude}&z=18&q=${latitude},${longitude}`;
        const win = window.open(url, '_blank');
        if (win) win.focus();
    }

    // ---------- Revision notes ----------
    toggleShowRevisionLog = () => {
        this.setState({ showRevisionLog: !this.state.showRevisionLog });
    }

    RevisionComponent = () => {
        if (this.props.data.message.text === "Revisi" && !this.state.showRevisionLog) {
            return (
                <Box sx={{ mt: "6px" }}>
                    <div className="wa-action-btn" onClick={this.loadRevisionNotes}>Lihat Catatan Revisi</div>
                </Box>
            );
        }
        if (this.props.data.message.text === "Revisi" && this.state.showRevisionLog === true) {
            return (
                <Box sx={{ mt: "6px", fontSize: "12px" }}>
                    <Box sx={{ fontWeight: 700 }}>Catatan Revisi</Box>
                    <Box sx={{ mt: "4px" }}>{this.state.revisoinLogs}</Box>
                </Box>
            );
        }
        return null;
    }

    loadRevisionNotes = () => {
        let text = this.props.data.repliedMessage.message.caption;
        text = text.replace("Foto hasil untuk PO ", "");
        axios
            .get(Api.getPoInfoById(text), Api.getRequestHeader())
            .then((response) => {
                if (response.data && response.data.success) {
                    this.setState({ revisoinLogs: response.data.data.revision_image_log });
                    this.toggleShowRevisionLog();
                }
            })
            .catch((error) => {
                console.error("There was an error!", error);
            });
    };

    // ---------- Status icon (ala WhatsApp) ----------
    renderStatusIcon = () => {
        const { data, isMine } = this.props;
        if (!isMine) return null;

        switch (data.status) {
            case "SEEN":
                return <ToolTip title="Sudah dibaca"><DoneAll className="wa-status-icon" sx={{ color: "#0a91e0" }} /></ToolTip>;
            case "DELIVERED_TO_HANDSET":
                return <ToolTip title="Sampai ke handset pelanggan"><DoneAll className="wa-status-icon" sx={{ color: "#46606e" }} /></ToolTip>;
            case "DELIVERED_TO_OPERATOR":
                return <ToolTip title="Terkirim ke server WA"><Done className="wa-status-icon" sx={{ color: "#46606e" }} /></ToolTip>;
            case "SENDING":
                return <ToolTip title="Sedang dikirim dan menunggu status pengiriman pesan dari provider"><QueryBuilder className="wa-status-icon" sx={{ color: "#5e7280" }} /></ToolTip>;
            case "UNDELIVERABLE_NOT_DELIVERED":
                return <ToolTip title={(<>Pesan tidak dapat dikirim<br />Coba kirim pesan HSM dulu</>)}><Error className="wa-status-icon failed" sx={{ color: "#e53935" }} /></ToolTip>;
            case "FAILED":
                return <ToolTip title="Pesan gagal dikirim"><Error className="wa-status-icon failed" sx={{ color: "#e53935" }} /></ToolTip>;
            case "FAILED_PERMANENTLY":
                return <ToolTip title="Pesan gagal dikirim"><ReportOff className="wa-status-icon failed" sx={{ color: "#e53935" }} /></ToolTip>;
            case "DELIVERY_REJECTED":
                return <ToolTip title="Pengiriman pesan di tolak oleh provider, coba kirim ulang pesan yang sama"><ReportOff className="wa-status-icon failed" sx={{ color: "#e53935" }} /></ToolTip>;
            case "NOSTATUS":
                return <ToolTip title="Jenis pesan tidak diketahui"><Help className="wa-status-icon failed" sx={{ color: "#e53935" }} /></ToolTip>;
            default:
                return null;
        }
    }

    render() {
        const { data, isMine, startsSequence, endsSequence, showTimestamp } = this.props;
        const friendlyTimestamp = Global.formatDateTimeToStrFormat(data.created_at, "LLLL");
        const timeOnly = Global.formatDateTimeToStrTime24(data.created_at, true);
        const messageText = data.message.type === "TEXT" ? data.message.text : data.message.caption;
        const isFormPemesanan = messageText?.toLowerCase()?.includes(Global.FORM_ORDER_MESSAGE_MARK.toLowerCase()) && !isMine;
        const isImageMessage = data.message.type === "IMAGE" || data.message.type === "STICKER";
        const isDocumentMessage = data.message.type === "DOCUMENT";
        const isAudioMessage = data.message.type === "AUDIO";
        const hasReply = data.repliedMessage !== undefined && data.repliedMessage !== null;
        const urls = this.getMessageUrls();

        // Bounding box untuk preview lokasi (OpenStreetMap)
        const boundaryRange = 0.009; // ~1 KM
        let minLong = 0, minLat = 0, maxLong = 0, maxLat = 0;
        if (data.message.type === "LOCATION") {
            minLong = data.message.location?.long - boundaryRange;
            minLat = data.message.location?.lat - boundaryRange;
            maxLong = data.message.location?.long + boundaryRange;
            maxLat = data.message.location?.lat + boundaryRange;
        }

        const imageSrc = (data.message.fileName !== undefined && data.message?.fileName?.startsWith("http"))
            ? data.message.fileName
            : Api.getBaseImageUrl() + data.message.fileName;

        return (
            <div className={[
                "wa-message",
                isMine ? "mine" : "",
                startsSequence ? "start" : "",
                endsSequence ? "end" : "",
            ].join(" ")}>

                {showTimestamp && <div className="wa-date-pill">{friendlyTimestamp}</div>}

                <div className="wa-row">

                    {/* Menu titik tiga (untuk pesan masuk) di kiri bubble */}
                    {(!isMine && this.props.onOpenCreateOrder) && (
                        <span>
                            <div className="wa-menu-trigger" onClick={this.handleClick}>
                                <MoreVert fontSize="small" />
                            </div>
                            <Menu
                                id={"menu-" + data._id}
                                anchorEl={this.state.anchorEl}
                                open={this.state.isMenuOpen}
                                onClose={this.handleClose}
                                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                            >
                                <MenuItem disabled={!(isFormPemesanan && (Global.get().admin || Global.isSales()))} onClick={this.props.onOpenCreateOrder(messageText)}>Create Order</MenuItem>
                                <MenuItem disabled={!isImageMessage} onClick={() => this.downloadFile((data.message.fileName?.startsWith("http") ? "" : Api.getBaseImageUrl()) + data.message.fileName)}>Download Image</MenuItem>
                                <MenuItem disabled={!isDocumentMessage} onClick={() => this.downloadFile(Api.getBaseDocsUrl() + data.message.fileName)}>Download Document</MenuItem>
                            </Menu>
                        </span>
                    )}

                    <div className="wa-bubble" 
                        // title={friendlyTimestamp}
                    >

                        {/* Reply quote */}
                        {hasReply && this.formatReplyMessage(data.repliedMessage)}

                        {/* Teks / caption */}
                        {this.formatText()}

                        {/* Preview URL ala WhatsApp */}
                        {urls.length > 0 && <LinkPreview key={urls[0]} url={urls[0]} />}

                        {/* Gambar / Sticker */}
                        {isImageMessage && (
                            <Box sx={{ mt: hasReply || this.formatText() ? "6px" : 0 }}>
                                <ImageZoom
                                    image={{ src: imageSrc, alt: '', className: 'wa-media-img' }}
                                    zoomImage={{ src: imageSrc, alt: '' }}
                                />
                                <div className="wa-action-btn" onClick={() => this.downloadFile((data.message.fileName?.startsWith("http") ? "" : Api.getBaseImageUrl()) + data.message.fileName)}>
                                    Download
                                </div>
                            </Box>
                        )}

                        {/* Lokasi */}
                        {data.message.type === "LOCATION" && (
                            <Box sx={{ cursor: "pointer" }} onClick={() => this.handleOpenMap(data.message.location?.lat, data.message.location?.long)}>
                                <iframe
                                    title={data.messageId}
                                    width="100%"
                                    height="150"
                                    frameBorder="0"
                                    scrolling="no"
                                    style={{ borderRadius: "6px", border: 0 }}
                                    src={`https://www.openstreetmap.org/export/embed.html?bbox=${minLong},${minLat},${maxLong},${maxLat}&layer=mapnik`}>
                                </iframe>
                                <Box sx={{ fontWeight: "bold", color: '#027eb5', mt: "8px", display: "flex", alignItems: "center", gap: "2px" }}>
                                    <LocationOn sx={{ fontSize: "17px", color: "#DC3545" }} />
                                    {data.message.location?.name}
                                </Box>
                                <Box sx={{ mt: "4px" }}>{data.message.location?.address}</Box>
                                <Box sx={{ fontSize: "11px", color: "#667781" }}>{data.message.location?.lat}, {data.message.location?.long}</Box>
                            </Box>
                        )}

                        {/* Dokumen */}
                        {data.message.type === "DOCUMENT" && (
                            <Box>
                                <div className="wa-action-btn" onClick={() => this.props.onDownloadDocument(data.message.fileName)}>
                                    <FaFile /> Buka dokumen
                                </div>
                                {data.status === "FAILED" && (
                                    <div className="wa-action-btn danger" onClick={() => this.props.onResendMessage(data)}>
                                        <Replay fontSize="small" /> Kirim ulang
                                    </div>
                                )}
                                <div className="wa-action-btn" onClick={() => this.downloadFile(Api.getBaseDocsUrl() + data.message.fileName)}>
                                    Download
                                </div>
                            </Box>
                        )}

                        {/* Kontak */}
                        {data.message.type === "CONTACTS" && (
                            <Box>
                                <List dense sx={{ mt: 0, width: '100%', maxWidth: 360, bgcolor: 'rgba(255,255,255,0.5)', px: "5px", py: 0, borderRadius: "8px" }}>
                                    {data.message.contacts?.map((item, idx) => (
                                        <ListItem key={idx} alignItems="flex-start" sx={{ padding: 0 }}>
                                            <ListItemAvatar>
                                                <Avatar sizes='small' alt={item.name.formatted_name} src="/static/images/avatar/1.jpg" />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={item.name.formatted_name}
                                                secondary={
                                                    <React.Fragment>
                                                        {item.phones?.map((phone, pidx) => (
                                                            <Typography key={pidx} component="span" variant="body2" sx={{ color: 'text.secondary', display: 'inline', fontSize: "11px" }}>
                                                                {phone?.phone?.replaceAll("+", "").replaceAll("-", "").replaceAll(" ", "")}
                                                            </Typography>
                                                        ))}
                                                    </React.Fragment>
                                                }
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                        )}

                        {/* Video */}
                        {data.message.type === "VIDEO" && (
                            <Box sx={{ mt: "6px", borderRadius: "6px", overflow: "hidden" }}>
                                <ReactPlayer width="100%" style={{ maxHeight: "250px" }} controls={true}
                                    url={data.message.fileName?.startsWith("http") ? data.message.fileName : Api.getBaseVideosUrl() + data.message.fileName} />
                            </Box>
                        )}

                        {/* Audio */}
                        {(isAudioMessage && data.message.fileName?.length > 0) && (
                            <Box sx={{ mt: "4px" }}>
                                <MyAudioPlayer currentSong={Api.getBaseAudiosUrl() + data.message.fileName} />
                            </Box>
                        )}

                        {/* Kotak pesan error */}
                        {this.state.showErrorMessage && (
                            <div className="wa-error-box">
                                <div className="wa-error-title">Error Message</div>
                                <div>{data.errorMessage || data.errorCodeDescription}</div>
                                <div>Message UUID : {data.messageId}</div>
                                <div>Message Record ID : {data._id}</div>
                                <div className="wa-error-copy" onClick={this.handleCopyErrorInfo}>
                                    {this.state.errorCopied
                                        ? (<><Check sx={{ fontSize: 14 }} /> Tersalin!</>)
                                        : (<><ContentCopy sx={{ fontSize: 14 }} /> Salin info</>)}
                                </div>
                            </div>
                        )}

                        {/* Catatan revisi */}
                        <this.RevisionComponent />

                        {/* Meta: jam + indikator status (ala WhatsApp, float kanan bawah) */}
                        <span className="wa-meta">
                            {data.markedAsRead && data.markedAsReadAt && (
                                <ToolTip title={"Dibaca oleh " + data.markedAsReadByName + " pada " + Global.formatDateTimeToStrDateTime24(data.markedAsReadAt)}>
                                    <Face sx={{ fontSize: "14px", color: "#9c27b0", cursor: "pointer" }} />
                                </ToolTip>
                            )}
                            {(data.errorMessage || data.errorCodeDescription) && isMine && (
                                <ToolTip title={data.errorMessage || data.errorCodeDescription}>
                                    <Announcement sx={{ fontSize: "15px", color: "#f86c3d", cursor: "pointer" }} onClick={this.toggleShowErrorMessage} />
                                </ToolTip>
                            )}
                            {data.isTemplate === 1 && isMine && (
                                <ToolTip title={`Pesan template - ${data.hsmName}`}>
                                    <Assignment sx={{ fontSize: "14px", color: "#027eb5" }} />
                                </ToolTip>
                            )}
                            <span>{isMine ? Global.maskPhoneNumber(data.to) : data.to} · {timeOnly}</span>
                            {this.renderStatusIcon()}
                        </span>

                        {/* clearfix untuk float meta */}
                        <div style={{ clear: "both" }} />
                    </div>
                </div>
            </div>
        );
    }
}

export default MessageBubble;
